/* Versão atual do Sisare Web */
export const APP_VERSION = '1.0.0.4'; // alterar a cada nova publicação/release 10/08/2026